import classNames from 'classnames';
import { TimelineGroup } from '@customTypes/timeline';
import { getStatusFlags } from '../utils/getStatusFlags';

interface TimelineLabelProps {
  group: TimelineGroup;
}

/** Second line under the label on md+ when there is supplemental copy (not the date — that uses `dateText` under the dot). */
function getDesktopSubLabelText(group: TimelineGroup): string | null {
  return group.secondaryText?.trim() ? group.secondaryText : null;
}

/** Second line under the label below md: prefer date; Reported uses "date (count)" when both exist. */
function getMobileSubLabelText(group: TimelineGroup): string | null {
  if (group.id === 'reported' && group.dateText && group.secondaryText) {
    return `${group.dateText} (${group.secondaryText})`;
  }
  if (group.dateText) {
    return group.dateText;
  }
  if (group.secondaryText) {
    return group.secondaryText;
  }
  return null;
}

export default function TimelineLabel({ group }: TimelineLabelProps) {
  const { isCompleted, hasProgress } = getStatusFlags(group.status);
  const desktopSubLabelText = getDesktopSubLabelText(group);
  const mobileSubLabelText = getMobileSubLabelText(group);
  const hasSubLabelText = !!desktopSubLabelText || !!mobileSubLabelText;

  return (
    <div
      className={classNames('timeline__group-label', {
        'timeline__group-label--completed': hasProgress,
        'timeline__group-label--no-sub': !hasSubLabelText,
      })}
    >
      <div className='fs-6 fw-bold timeline__label-text'>{group.label}</div>
      <div
        className={classNames('timeline__group-label__sub', {
          'timeline__group-label--sub-label-completed': isCompleted && hasSubLabelText,
        })}
      >
        <div className='timeline__group-label__sub-line timeline__group-label__sub-line--desktop'>
          {desktopSubLabelText ?? ''}
        </div>
        <div className='timeline__group-label__sub-line timeline__group-label__sub-line--mobile'>
          {mobileSubLabelText ?? ''}
        </div>
      </div>
    </div>
  );
}
